import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { lastValueFrom, map } from 'rxjs';
import { BaseResponse, ResponseObject } from '../common/interfaces/global-interfaces';
import * as fromGraphql from '../store/entities/uaa/auth-user.graphql'
import { AuthUserProfile, OTPInputObject, ProfileInputObject, ResendOTPMutation, VerificationTypeChoices } from '../store/entities/uaa/auth-user.model';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(
    private apollo: Apollo,
  ) { }


  async verifyOtp(formData: OTPInputObject): Promise<ResponseObject> {
    return await lastValueFrom (
      this.apollo.mutate({
        mutation: fromGraphql.VERIFY_OTP,
        variables: formData
      }).pipe(
        map(({ data }: any) => {
          const result: BaseResponse<any> = data?.verifyOtpMutation;
          return result?.response;
        })
      )
    );
  }


  async verifyPhoneNumber(phoneNumber: string, verificationType: VerificationTypeChoices): Promise<ResponseObject> {
    return await lastValueFrom (
      this.apollo.mutate({
        mutation: fromGraphql.VERIFY_PHONE_NUMBER,
        variables: {
          phoneNumber,
          verificationType
        }
      }).pipe(
        map(({ data }: any) => {
          const result: BaseResponse<any> = data?.verifyPhoneNumberMutation;
          return result?.response;
        })
      )
    );
  }


  async resendOtp(phoneNumber: string): Promise<ResendOTPMutation> {
    return await lastValueFrom (
      this.apollo.mutate({
        mutation: fromGraphql.RESEND_OTP,
        variables: {
          phoneNumber: phoneNumber
        }
      }).pipe(
        map(({ data }: any) => {
          const result: ResendOTPMutation = data?.resendOtpMutation;
          return result;
        })
      )
    );
  }


  async registerComplainantUser(formData: ProfileInputObject): Promise<ResponseObject> {
    return await lastValueFrom (
      this.apollo.mutate({
        mutation: fromGraphql.CREATE_COMPLAINANT_USER,
        variables: {
          input: formData
        }
      }).pipe(
        map(({ data }: any) => {
          const result: BaseResponse<any> = data?.createComplainantUserMutation;
          return result?.response;
        })
      )
    );
  }


  async updateComplainantUser(formData: ProfileInputObject): Promise<BaseResponse<AuthUserProfile>> {
    return await lastValueFrom (
      this.apollo.mutate({
        mutation: fromGraphql.UPDATE_COMPLAINANT_USER,
        variables: {
          input: formData
        }
      }).pipe(
        map(({ data }: any) => {
          const result: BaseResponse<AuthUserProfile> = data?.updateUserProfileMutation;
          return result;
        })
      )
    );
  }

}
